const GLOBAL_URL = {
  YOUTUBE_URL: "https://www.youtube.com/watch?v=avXAysd6WHQ",
};

export default GLOBAL_URL;
